var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 36,
    height: 36,
    rx: 18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4445_16311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6942 9.99512C12.2547 9.99512 12.6935 10.1718 13.0124 10.5235C13.3313 10.8753 13.5022 11.319 13.5252 11.8508C13.5252 12.3759 13.346 12.8188 12.9853 13.1788C12.6245 13.5379 12.1314 13.7179 11.5077 13.7179H11.4855C10.8765 13.7179 10.3941 13.5379 10.035 13.1788C9.67998 12.8188 9.5 12.3759 9.5 11.8508C9.5 11.3108 9.69559 10.8671 10.0901 10.5178C10.4845 10.1693 11.0203 9.99512 11.6942 9.99512ZM9.73586 15.1922H13.5844V26.0039H9.73586V15.1922ZM27.5 19.805V26.0039H23.6523V20.2217C23.6523 19.4861 23.5011 18.8969 23.2003 18.4482C22.9012 18.0036 22.4007 17.7809 21.6939 17.7809C21.1557 17.7809 20.7234 17.9173 20.4012 18.1918C20.0783 18.4646 19.8441 18.7662 19.7027 19.0974C19.6567 19.2174 19.6279 19.3497 19.6123 19.4968C19.5975 19.6415 19.5909 19.7984 19.5909 19.9636V26.0047H15.7194C15.7359 24.1754 15.7449 22.4972 15.7449 20.9753V19.0531V17.3067C15.7449 16.775 15.7391 16.3214 15.7301 15.945C15.7252 15.5719 15.7194 15.3196 15.7194 15.1922H19.5909V16.7232L19.5696 16.7676H19.5909V16.7232C19.7109 16.535 19.8646 16.3386 20.052 16.1324C20.2418 15.9269 20.4686 15.7346 20.7448 15.5571C21.0184 15.3812 21.348 15.2366 21.7342 15.1191C22.1229 15.0032 22.5651 14.9457 23.0688 14.9457C23.695 14.9457 24.2802 15.041 24.8258 15.2325C25.3699 15.424 25.8375 15.7239 26.2352 16.1332C26.6305 16.54 26.9404 17.0462 27.1655 17.6511C27.3899 18.2543 27.5 18.9725 27.5 19.805Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4445_16311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9.5 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.59ab35243548deadda187056e9f56f60.svg";
export { ForwardRef as ReactComponent };